<template>
   <form action="careers" method="GET">
      <main role="main" class="container search">
         <br /><br />

         <div class="row flex-shrink-0">
            <div class="col-lg-6 offset-lg-3 col-md-10 offset-md-1 text-center">
               <a href="https://uptimeinstitute.com/education" target="_blank">
                  <img
                     src="~@/assets/images/uptime-logo.png"
                     alt="Uptime Institute logo"
                     class="logo"
                  />
               </a>
               <h1>Data Center Career Pathfinder</h1>
               <div class="powered-by">
                  <span class="h5"> In collaboration with </span>
                  <!--img
                  src="~@/assets/images/uptime-logo.png"
                  alt="Uptime Institute logo"
                  class="logo"
               / -->
                  <div>
                     <a href="https://www.google.com/about/datacenters/life" target="_blank">
                        <img
                           src="~@/assets/images/google-sized.svg"
                           alt="Google logo"
                           class="home-partner-logo"
                        />
                     </a>
                     <a
                        href="https://www.metacareers.com/areas-of-work/infrastructure"
                        target="_blank"
                     >
                        <img
                           src="~@/assets/images/meta-sized.svg"
                           alt="Meta logo"
                           class="home-meta-logo"
                        />
                     </a>
                     <a
                        href="https://careers.microsoft.com/us/en/c/data-center-jobs"
                        target="_blank"
                     >
                        <img
                           src="~@/assets/images/microsoft-sized.svg"
                           alt="Microsoft logo"
                           class="home-partner-logo"
                        />
                     </a>
                  </div>
               </div>
            </div>

            <div class="col-lg-6 offset-lg-3 col-md-10 offset-md-1 search-content">
               <p>
                  Data centers are the engines of our digital world. This fast-growing sector is
                  hiring for almost every skill set, educational level and stage of career
                  development.
               </p>

               <p>
                  How can your skills and unique background transfer to a data center career?
                  Discover the hundreds of options by clicking below.
               </p>

               <center>
                  <router-link to="categories">
                     <button type="button" class="btn btn-primary btn-lg">
                        Explore Career Options
                     </button>
                  </router-link>
               </center>

               <hr />

               <h2>Discover different career paths</h2>

               <p>
                  Do you enjoy solving problems? Can you communicate clearly? Think creatively? Or
                  perhaps you have technical aptitude or a strong sense of leadership?
               </p>

               <p>
                  Click below to explore the data center career paths that fit with your skills and
                  competencies, no matter what your industry background or level of experience.
               </p>

               <router-link to="categories">
                  <img src="~@/assets/images/job-domains.png" alt="Job Domains" />
               </router-link>

               <hr />

               <h2>Why choose a data center career?</h2>

               <p>
                  <b>Job security.</b> Data centers power many of the technologies we use daily,
                  including the internet. As demand for digital services grows, so does demand for
                  data center jobs. This is one of the fastest-growing sectors today and in the
                  future.
               </p>

               <p>
                  <b>Job variety.</b> A data center career is not one size fits all. Just as the
                  people working in data centers represent a diverse range of skills and
                  backgrounds, there are many different types of jobs and careers ranging from
                  hands-on to technical, and from business or engineering to community development.
               </p>

               <p>
                  <b>Career growth.</b> The data center sector offers many different opportunities
                  to grow, from entry-level to leadership roles. Data center teams are
                  multi-disciplinary, which means people develop a range of skills and perspectives.
               </p>

               <p>
                  <b>Personal growth.</b> Develop new skills, get trained and learn the latest.
                  There is a wide range of job roles and career paths, which means opportunities for
                  growth.
               </p>

               <hr />

               <h2>Fast-growing opportunities</h2>

               <img
                  src="~@/assets/images/fast-growing-opportunities.png"
                  alt="Fast Growing Opportunities"
               />

               <p>
                  Demand for staff in the global data center infrastructure sector is forecast to
                  rise from about 2.0 million full-time employees in 2019 to nearly 2.3 million in
                  2025. There is high demand for all types of job roles and in different types and
                  sizes of data centers, globally.
               </p>
               <hr />
            </div>
         </div>
      </main>
   </form>
</template>

<script>
// uses jquery for autocomplete
// import $ from 'jquery';
// import 'jquery-ui';

export default {
   name: 'Home',
   /* Removed as search box is now gone
   mounted: function() {
      $('#searchbox').autocomplete({
         source: this.$predictiveArray(),
      });
   },
   */
   methods: {
      pushCategories: function () {
         this.$router.push({
            path: 'categories',
         });
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue